import { render, staticRenderFns } from "./belumDitempatkan.vue?vue&type=template&id=756a45bf"
import script from "./belumDitempatkan.vue?vue&type=script&lang=js"
export * from "./belumDitempatkan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports